import React from 'react';

import { Dialog, Drawer, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';

import { useIsDesktop } from '../hooks/use-is-desktop.hook';

const PANEL_TITLE_ID = 'responsive-panel-title';

interface ResponsivePanelProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children?: React.ReactNode;
}

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    width: 440,
    maxWidth: '100%',
    borderRadius: 16,
  },
  drawerPaper: {
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    maxHeight: '90vh',
    '@media (prefers-reduced-motion: reduce)': {
      transition: 'none !important',
    },
  },
  handle: {
    width: 40,
    height: 4,
    borderRadius: 2,
    backgroundColor: theme.palette.grey[300],
    margin: '8px auto 0',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 3, 1),
  },
  closeButton: {
    minWidth: 44,
    minHeight: 44,
  },
  content: {
    padding: theme.spacing(1, 3, 3),
    overflowY: 'auto',
  },
}));

const ResponsivePanel: React.FC<ResponsivePanelProps> = ({ open, title, onClose, children }) => {
  const classes = useStyles();
  const isDesktop = useIsDesktop();

  const body = (
    <React.Fragment>
      {!isDesktop && <div className={classes.handle} />}
      <div className={classes.header}>
        <Typography id={PANEL_TITLE_ID} variant="h6" component="h2">
          {title}
        </Typography>
        <IconButton className={classes.closeButton} aria-label="Fermer" onClick={onClose}>
          <Close />
        </IconButton>
      </div>
      <div className={classes.content}>{children}</div>
    </React.Fragment>
  );

  if (isDesktop) {
    return (
      <Dialog open={open} onClose={onClose} aria-labelledby={PANEL_TITLE_ID} classes={{ paper: classes.dialogPaper }}>
        {body}
      </Dialog>
    );
  }

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      ModalProps={{ role: 'dialog', 'aria-labelledby': PANEL_TITLE_ID }}
      classes={{ paper: classes.drawerPaper }}
    >
      {body}
    </Drawer>
  );
};

export default ResponsivePanel;
